import React, { Component } from 'react';
export default class DropboxRedirect extends Component {

  constructor() {
    super();
    this.parseQueryString = this.parseQueryString.bind(this);
  }

  parseQueryString(str) {
      var ret = Object.create(null);

      if (typeof str !== 'string') {
        return ret;
      }

      str = str.trim().replace(/^(\?|#|&)/, '');

      if (!str) {
        return ret;
      }

      str.split('&').forEach(function (param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;

        key = decodeURIComponent(key);

        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);

        if (ret[key] === undefined) {
          ret[key] = val;
        } else if (Array.isArray(ret[key])) {
          ret[key].push(val);
        } else {
          ret[key] = [ret[key], val];
        }
      });

      return ret;
  }

  isDropboxReady() {
    return !!window.Dropbox;
  }

  componentDidMount() {
    let self = this;
     window.addEventListener('load', function() {
        var message = self.parseQueryString(window.location.hash);
        window.location.hash = '';

        let opener = window.opener;
        if (window.parent !== window.top) {
            opener =  opener || window.parent
        }

        if (opener) {
          opener.postMessage(message, window.location.origin);
          window.close();
        }
        

    });
  }

  render() {
    return (
      <div id='dropbox-redirect'>Redirecting...</div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/singletons/dropbox-redirect.js